import { swiperHome, swiperEmprendimientosDestacados, swiperManantiales,  swiperManantialesFicheros, swiperManantialesBtn, swiperOportunidades,swiperEmprendimientos} from '../functions/swiperInit.js';
import { counterJS } from '../functions/counter.js';

document.addEventListener("DOMContentLoaded", () => {

    counterJS();

    /* --------------- Sliders --------------- */
    swiperHome();
    swiperEmprendimientosDestacados();
    swiperManantialesBtn;
    swiperManantiales;
    swiperManantialesFicheros;
    swiperOportunidades();
    swiperEmprendimientos();

    swiperManantiales.controller.control = swiperManantialesFicheros;
    swiperManantialesFicheros.controller.control = swiperManantiales;
});
